import { PreviousMaritalRegimeType } from "../../types/commonTypes/previousMaritalRegimeType";

export const previousMaritalRegimeInitialState: PreviousMaritalRegimeType = {
    previousRegime: "Communauté de biens réduite aux acquêts",
    weddingDate: "",
    weddingPlace: ""
}